import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 */
export class RecommendedPriceSellerValueObject extends ValueObject {
  /**
   * @param {Object}  deps
   * @param {Number}  deps.manufacturerPrice
   * @param {String}  deps.predictedPrice
   * @param {String}  deps.predictedRatio
   * @param {Number}  deps.roundedRecommendPrice
   */
}
